import { RoutePaths } from 'constants/RoutePaths';
import { UserRoles, patronRoles } from 'constants/userRoles';

export type NavItem = {
  id: string;
  labelKey: string;
  path: RoutePaths;
  roles?: string[];
};

export const NAV_ITEMS: NavItem[] = [
  { id: 'home', labelKey: 'navbar.home', path: RoutePaths.HOME },
  { id: 'profile', labelKey: 'navbar.profile', path: RoutePaths.PROFILE },
  { id: 'trainings', labelKey: 'navbar.trainings', path: RoutePaths.TRAININGS, roles: patronRoles },
  { id: 'users', labelKey: 'navbar.users', path: RoutePaths.USERS_MANAGEMENT, roles: patronRoles },
  { id: 'live', labelKey: 'navbar.live', path: RoutePaths.LIVE, roles: [UserRoles.ADMIN, UserRoles.Patron] },
  { id: 'statistics', labelKey: 'navbar.statistics', path: RoutePaths.STATISTICS, roles: patronRoles },
];

export const isNavItemVisible = (item: NavItem, userRole: string) =>
  !item.roles || item.roles.includes(userRole);

export const isNavItemActive = (item: NavItem, pathname: string) =>
  pathname === item.path || pathname.startsWith(`${item.path}/`);